export const SET_FILTER = 'SET_FILTER';
export const SET_FILTER_ADD_ASSISTANT = 'SET_FILTER_ADD_ASSISTANT';
export const SET_ALL_COLLABORATOR = 'SET_ALL_COLLABORATOR';
export const SET_COLLABORATOR = 'SET_COLLABORATOR';
export const SET_COLLABORATOR_ONLINE = 'SET_COLLABORATOR_ONLINE';
export const DELETE_COLLABORATOR = 'DELETE_COLLABORATOR';
export const MODIFY_COLLABORATOR = 'MODIFY_COLLABORATOR';
export const DELETE_ALL_COLLABORATOR = 'DELETE_ALL_COLLABORATOR';
export const APPLY_FILTER_COLLABORATOR = 'APPLY_FILTER_COLLABORATOR';
export const ADD_COLLABORATOR = 'ADD_COLLABORATOR';
